import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { companiesService, Company, CreateCompanyRequest } from '@aslanpay/portal-common-lib';

const useCreateCompany = ({
  onSuccess,
  onError,
}: UseMutationOptions<Company, Error, CreateCompanyRequest>) => {
  return useMutation<Company, Error, CreateCompanyRequest>(
    ({
      name,
      displayName,
      countryCode,
      companyNumber,
      feeGroup,
      address,
      companyConfig,
      type,
      partnerId,
    }: CreateCompanyRequest) =>
      companiesService.createCompany({
        name,
        displayName,
        countryCode,
        companyNumber,
        feeGroup,
        address,
        companyConfig,
        type,
        partnerId,
      }),
    { onSuccess, onError }
  );
};

export default useCreateCompany;
